import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    columnHeader: {
        color: theme.palette.primary.dark,
    },
    button: {
        border: "none",
        background: "transparent",
        cursor: "pointer",
    },
    editIcon: {
        color: theme.palette.primary.dark,
    },
    waiting: {
        color: theme.palette.error.main,
        fontStyle: "italic",
    },
    toBeDefined: {
        fontStyle: "italic",
    },
    icon: {
        color: `${theme.palette.warning.main} !important`,
        width: "26px !important",
        height: "26px !important",
    },
    alertMessage: {
        position: "absolute",
        transform: "translate(0, -50%)",
        transformOrigin: "right center",
        left: "auto",
        right: "40px",
        top: "50%",
        zIndex: 1,
        padding: "1px !important",
        "& .MuiAlert-message": {
            display: "flex",
            alignItems: "center",
            gap: "4px",
            padding: 0,
            whiteSpace: "nowrap",
        },
    },
}));
